import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL;

const api = axios.create({
  baseURL: BASE_URL,
  headers: { "Content-Type": "application/json" }
});

api.interceptors.request.use(config => {
  const token = localStorage.getItem("bwillis_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  res => res,
  err => {
    if (err.response && err.response.status === 401) {
      let wasStudent = false;
      try {
        const stored = JSON.parse(localStorage.getItem("bwillis_user"));
        wasStudent = stored?.role === "Student";
      } catch (e) { /* ignore */ }
      localStorage.removeItem("bwillis_token");
      localStorage.removeItem("bwillis_user");
      window.location.href = wasStudent ? "/portal/login" : "/bwillis/login";
    }
    return Promise.reject(err);
  }
);
console.log('API DEF',api)

export default api;
